/**
 * SessionBootScreen — a `BootScreen` já ligada ao estado de boot do AuthContext.
 *
 * Existe para que os call sites (RootEntry, ProtectedRoute, BetaAccessGate) não
 * repitam a fiação `bootFailure`/`retryBoot`. A `BootScreen` fica pura e
 * testável sem provider; esta aqui é a que as rotas usam.
 */

import { useAuth } from "../../hooks/useAuth";
import { useWideDesktopFrame } from "../../lib/layout/desktopShell";
import { BootScreen } from "./BootScreen";

export function SessionBootScreen({ message }: { message?: string }) {
  const { bootFailure, retryBoot } = useAuth();
  // Dentro da casca de desktop o boot ocupa a área inteira ao lado da barra
  // lateral, e não a coluna de 430px (05/10: a coluna com o boot era o "abre
  // como celular"). Fora da casca não faz nada.
  useWideDesktopFrame();
  return <BootScreen failureCode={bootFailure} onRetry={retryBoot} message={message} />;
}
